import { Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScrollService } from '../../services/scroll.service';

@Directive({
  selector: '[appScrollElement]',
  standalone: true,
})
export class ScrollElementDirective implements OnDestroy {
  private el = inject(ElementRef);
  private scrollService = inject(ScrollService);
  scrollSub: Subscription;
  constructor() {
    this.el.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    this.scrollService.registerScroll();
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('scroll', this.onScroll.bind(this));
  }
}
